import * as ActionTypes from './ActionTypes';

export const setInvitationForConference = (conference) => ({
    type: ActionTypes.SET_CONFERENCE_CALL_INVITATION,
    payload: conference,
});

export const clearInvitationForConference = (conference) => ({
    type: ActionTypes.CLEAR_CONFERENCE_CALL_INVITATION,
});

export const setConferenceData = (roomId, conferenceId, teamId, options = {}) => {
    return (dispatch) => {
        if (options?.onlyDispatchRoomConference) {
            dispatch(setRoomConferences({ roomId, conferenceId, teamId }));
        } else {
            dispatch(setConferenceDataSingleObj(roomId, conferenceId, teamId));
            dispatch(setRoomConferences({ roomId, conferenceId, teamId }));
        }
    };
};

export const setConferenceDataSingleObj = (roomId, conferenceId, teamId) => ({
    type: ActionTypes.SET_CONFERENCE_DATA,
    payload: {
        roomId,
        conferenceId,
        teamId,
    },
});

export const setRoomConferences = (options = {}) => {
    const roomId = options?.roomId;
    const teamId = options?.teamId || undefined;
    const conferenceId = options?.conferenceId;
    if (!roomId) {
        return { type: 'CONFERENCE_ROOM_ID_MISSING' };
    }
    const _payload = { roomId, teamId, conferenceId };
    return {
        type: ActionTypes.SET_ROOM_CONFERENCES,
        payload: { ..._payload },
    };
};

export const startRoomConference = ({ roomId }) => ({
    type: ActionTypes.START_ROOM_CONFERENCE,
    payload: { roomId },
});

export const startConference = () => ({
    type: ActionTypes.START_CONFERENCE,
});
